import * as React from "react";
import { findDOMNode } from "react-dom";
import {
  DragSource,
  DropTarget,
  DragSourceConnector,
  DragSourceMonitor,
  DropTargetMonitor,
  DropTargetConnector
} from "react-dnd";
import { flow } from "lodash";

const ItemTypes = {
  LISTITEM: "LISTITEM"
};

const listItemSource = {
    beginDrag(props) {
        var obj = {
            id: props.id,
            index: props.index
        };
        props.onBeginDrag(obj);
        return obj;
    },
  
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }

        props.onDropped();
    },
};

const listItemTarget = {
  hover(props, monitor, component) {
  
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.moveListItem(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

function collect(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

function dropCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}

export interface ISortableListItemProps extends React.Props<SortableListItem> {
  children?: any;
  connectDragSource: Function;
  connectDragPreview: Function;
  connectDropTarget: Function;
  moveListItem: Function;
  isDragging: boolean;
  active: boolean;
  id: number;
}

class SortableListItem extends React.Component<ISortableListItemProps, any> {
  render() {
    const {
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      isDragging,
      active
    } = this.props;

    return active ? connectDropTarget(
      connectDragPreview(
        <div className="sortable-list-item ">
          <div className="float-left mr-2 mt-2" style={{ width: "60px" }}>
            {connectDragSource(
              <span
                style={{
                  cursor: "move"
                }}
              >
                <i
                  className={`fa fa-drag-handle fa-lg mr-2`}
                  style={{
                    padding: ".5rem 1rem",
                    fontWeight: 400,
                    color: "#818183",
                    verticalAlign: "middle"
                  }}
                  aria-hidden="true"
                />
              </span>
            )}
          </div>
          <div className="">{this.props.children}</div>
        </div> 
      )
    ) : this.props.children;
  }
}

export default flow(
  DragSource(ItemTypes.LISTITEM, listItemSource, collect),
  DropTarget(ItemTypes.LISTITEM, listItemTarget, dropCollect)
)(SortableListItem) as any;



// WEBPACK FOOTER //
// ./src/components/Controls/SortableListItem.tsx